import { Page } from '../../types'
import { COUNTRIES } from '../../defaultContent'

const addRecoveredFraud: Page[] = [
    {
        pageType: 'information',
        title: 'Before you start',
        name: 'before-you-start',
        description:
            'Refers to the amount of fraud recovered within the given quarter. Entries should record the number of instances and the value of the loss relating to the fraud. Entries must include selections from the following typology dropdowns:'+
            '<ul><li>the business area affected by the fraud</li><li>who committed the original fraud?</li><li>the nature of deception - whether the prevented fraud involved a False Representation, a Failure to Declare/Disclose, or an Abuse of Position</li><li>The detailed nature of deception - a dependent dropdown selection on the specifics of the fraudulent activity</li><li>the type of recovery that enabled the funds to be recovered</li><li>whether or not the fraud related to a COVID-19 scheme or activity</li></ul><br/>'
    },
    {
        pageType: 'question',
        title: 'Recovered fraud',
        name: 'recovered-fraud',
        description:
            'Refers to the amount of fraud recovered within the given quarter. Entries should record the number of instances and the value of the loss relating to the fraud. Entries must include selections from the following typology dropdowns:'+
            '<ul><li>the business area affected by the fraud</li><li>who committed the original fraud?</li><li>the nature of deception - whether the prevented fraud involved a False Representation, a Failure to Declare/Disclose, or an Abuse of Position</li><li>The detailed nature of deception - a dependent dropdown selection on the specifics of the fraudulent activity</li><li>the type of recovery that enabled the funds to be recovered</li><li>whether or not the fraud related to a COVID-19 scheme or activity</li></ul><br/>',
        questions: [
            {
                questionType: 'radio',
                title: 'Do you have any instances of recovered fraud to declare?',
                name: 'recovered-fraud-declare',
                options: ['Yes', 'No'],
                rules: {
                    required: true
                }
            }
        ]
    },
    {
        pageType: 'list',
        title: 'Add an instance',
        name: 'recovered-fraud-add-instance',
        description:
            'Refers to the amount of fraud recovered within the given quarter. Entries should record the number of instances and the value of the loss relating to the fraud. Entries must include selections from the following typology dropdowns:'+
            '<ul><li>the business area affected by the fraud</li><li>who committed the original fraud?</li><li>the nature of deception - whether the prevented fraud involved a False Representation, a Failure to Declare/Disclose, or an Abuse of Position</li><li>The detailed nature of deception - a dependent dropdown selection on the specifics of the fraudulent activity</li><li>the type of recovery that enabled the funds to be recovered</li><li>whether or not the fraud related to a COVID-19 scheme or activity</li></ul><br/>',
        disabled: [
            {
                field: 'recovered-fraud-declare',
                condition: 'equals', // optional
                value: 'No'
            }
        ],
        questions: [
            {
                questionType: 'select',
                title: 'Which spending area did the fraud occur in?',
                name: 'recovered-fraud-area',
                detailsHeading: 'Help with spending areas',
                detailsContent: ' <b>Procurement:</b> Goods or services bought by public sector organisations (including suppliers)' +
                                ' <br/><b>Personnel:</b> Employees (including contractors and agency workers).' +
                                ' <br/><b>Subsidies:</b> Support or incentives given by the government.' +
                                ' <br/><b>Grants:</b> Money given by a public sector organisation for a specific purpose.' +
                                ' <br/><b>Loans & credit guarantees:</b> Money given by a public sector organisation for a specific purpose.' +
                                ' <br/><b>Charges & other non-tax income:</b> Money owed to public sector organisations (for example, court fines or prescription fees)' +
                                ' <br/><b>Licenses and permits:</b> Personal or business licenses (for example, a Blue Badge or Surveyor license)' +
                                ' <br/><b>Tax & Duties:</b> Mandatory government charge for goods, income or services' +
                                ' <br/><b>Benefits:</b> Money given by the government to support members of the public' +
                                ' <br/><b>Special Payments:</b> Money given in unique or specific circumstances (for example, compensation)',
                options: ['Procurement','Personnel','Subsidies','Grants','Loans & credit gurantees','Charges & other non-tax income','Licences and permits','Tax & Duties','Benefits','Special payments'],
                hintOption: 'Select an option',
                rules: {
                    required: true
                },
                errorMessages: { required: 'This field is mandatory' }
            },    
            {
                questionType: 'select',
                title: 'Who was responsible for the fraud?',
                name: 'recovered-fraud-responsible',
                detailsHeading: 'Help with responsibility',
                detailsContent: '<b>Third sector organisations:</b> a non-governmental organisation (for example, charities, social enterprises, and voluntary groups)' +
                ' <br/><b>Private sector - company:</b> a business owned by shareholders but run by its directors' +
                ' <br/><b>Private sector - partnerships:</b> a business owned and run by its partners' +
                ' <br/><b>Private sector - self employed:</b> in their role as a self-employed person (for example, a sole trader)' +
                ' <br/><b>Public sector organisations:</b> (for example, NHS Trusts, higher education providers and academies)' +
                ' <br/><b>Members of the general public:</b> in their role as member of the public' +
                ' <br/><b>Hostile third party:</b> (for example, foreign states, "hacktivist" groups and organised crime groups)'+
                ' <br/><b>Public sector employees:</b> in their role as a person employed by the government (for example, a public servant or health care employee)' +
                ' <br/><b>Contingent labour:</b> in their role as a person contracted to supply a service or contingent labour to government' +
                ' <br/><b>Other public servants:</b> in their role as person supporting the government without pay (for example, jurors, volunteers or magistrates)' +
                ' <br/><b>Unknown:</b> I dont know who was responsible for the fraud',
                options: ['Third sector organisations','Private sector - company','Private sector - partnerships','Private sector - self employed','Public sector organisations','Members of the graneral public','Hostile third party','Public sector employees','Contigent labour','Other public servants','Unknown'],
                hintOption: 'Select an option',
                rules: {
                    required: true
                },
                errorMessages: { required: 'This field is mandatory' }
            },        
            {
                name: 'recovered-fraud-deception',
                questionType: 'radio',
                title: 'What was the general nature of deception?',
                detailsHeading: 'Help with general nature of deception',
                detailsContent: ' <b>Abuse of position:</b> use of a persons position or role in the goverment or public sector'+
                                ' <br/><b>Failure to declare/disclose:</b> Intentionally omitting information you legally need to share' +                
                                ' <br/><b>False Representation:</b> intentionally hiding or giving misleading information'+
                                ' <br/><b>Unknown:</b> I dont know how the deception was committed.',
                options: ['Abuse of position', 'Failure to declare/disclose','False Representation','Unknown'],
                rules: {
                    required: true
                }
            },         
            {
                questionType: 'select',
                title: 'What was the specific nature of deception?',
                name: 'recovered-fraud-mandate-fraud',
                detailsHeading: 'Help with specific nature of deception',
                detailsContent: '<b>Change of Circumstance:</b> using or providing a different product or service than promised or misrepresenting the need for a product or service' +
                ' <br/><b>Asset misappropriation:</b> misuse of government property (for example, a laptop or phone)' +
                ' <br/><b>Charge evasion:</b> giving misleading information to evade paying money (for example, fees, taxes or fines)' +
                ' <br/><b>Abuse of working hours:</b> falsely claiming time worked (for example, flexitime or annual leave)'+
                ' <br/><b>Application for employment:</b> using misleading information to get a role (for example, employment history or qualifications)' +
                ' <br/><b>Misuse of funding::</b> using funds outside the conditions of the agreement'+
                ' <br/><b>Mandate fraud:</b> changing a payment mandate (for example, details for a standing order)' +
                ' <br/><b>Travel, Expenses and Subsistence:</b> falsely claiming on government expenses (for example, travel or food)' ,
                options: ['Change of Circumstance','Asset Misappropriation','Charge evasion','Application for employment','Misuse of funding','Misuse of funding','Travel, Expenses and Subsistence'],
                hintOption: 'Select an option',
                rules: {
                    required: true
                },
                errorMessages: { required: 'This field is mandatory' }
            },           
            {
                questionType: 'instanceInput',
                title: 'How many instances occurred',
                name: 'recovered-fraud-impact',
                hint: 'Total number of instances',
                rules: {
                    required: true
                }
            },
            {
                questionType: 'costInput',
                title: 'What was the value of the fraud?',
                name: 'recovered-fraud-estimated-total',
                hint: 'Total value',
                rules: {
                    required: false
                }
            },            
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'recovered-fraud-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            },   
            {
                questionType: 'checkbox',
                title: 'How was the fraud recovered (fully or partially)',
                name: 'recovered-fraud-support',
                detailsHeading: 'Help with recovery',
                detailsContent: '<b>Offsetting:</b> loss offset against their personal income (for example, salary or benefits).'+
                '<br><b>Voluntary repayment:</b> the offender pays back the loss voluntarily.'+
                '<br><b>Through civil proceedings:</b> the offender is forced to pay back the loss because of civil proceedings.'+
                '<br><b>Through criminal proceedings:</b> the offender is forced to pay back the loss because of criminal proceedings.'+
                '<br><b>Unknown:</b>  I dont know how it was recovered.',
                hint: 'Tick all that apply',
                options: ['Offsetting', 'Voluntary repayment', 'Through civil proceedings', 'Through criminal proceedings','Unknown'],
                rules: { required: true }
            },   
            {
                questionType: 'radio',
                title: 'Does this relate to BAU or C19 activity?',
                hint: '',
                name: 'recovered-fraud-bau-c19',
                options: ['Business as usual (BAU)', 'Covid-19 (C19)'],
                rules: { required: true }
            }
        ]
    },
]
export default addRecoveredFraud
